import { formatBudgetBalance } from '../../shared/format_currency.js';
import type { CheckoutBudgetCopy } from '../model/checkout_copy.js';
import type { CheckoutBudget } from '../model/checkout_source.js';
import type { BudgetLighthouseProps } from '../traveler/budget_lighthouse.js';

/** O estado do farol de orçamento (design spec §Budget, item 1). Confia no
 *  `hasLimit` do servidor para a insuficiência; o âmbar espelha o aviso não
 *  bloqueante "saldo < total" do checkout legado; nunca entra no `canSubmit`.
 *  Sem controle ou com erro não há o que reportar: `undefined`. */
export function budgetLighthouse(
  budget: CheckoutBudget | undefined,
  total: number,
  /** Nome do centro de custo escolhido ("Limite suficiente em {{costCenter}}…"). */
  costCenterName: string | undefined,
  copy: CheckoutBudgetCopy,
  locale: string,
): BudgetLighthouseProps | undefined {
  if (!budget?.hasControl || budget.hasError) return undefined;
  if (!budget.hasLimit) {
    return {
      tone: 'insufficient',
      title: copy.insufficient,
      detail: `${copy.available}: ${formatBudgetBalance(
        budget.balance,
        budget.currency ?? 'BRL',
        budget.symbol,
        locale,
      )}`,
    };
  }
  if (budget.balance < total) {
    return { tone: 'warning', text: copy.warning };
  }
  return {
    tone: 'ok',
    text: costCenterName ? copy.sufficientIn(costCenterName) : copy.sufficient,
  };
}
